/**
 * Decide whether a navigation should leave the page where the user scrolled it.
 *
 * Pages that open modals synced to the query string (e.g. candidate_id) opt in w/
 * `meta.keepScrollOnQueryChange`, so opening or closing one doesn't jump to the top.
 * Path changes still scroll to the top as usual.
 */
export function keepsScrollPosition(to, from) {
  return Boolean(to.meta?.keepScrollOnQueryChange) && to.path === from.path;
}
